import React from 'react'
import { useInfiniteQuery } from '@tanstack/react-query'
import { queryKeys } from '@core/Data/ReactQuery/constants'
import { AutoFetchButton } from '@core/Components/AutoFetchButton'
import { getBetLoopSuggestedProfiles } from '@core/Areas/BetLoop/helpers/api'
import { BetLoopFeedPageSize } from '@core/Areas/BetLoop/constants'

export const useExploreSuggestedProfiles = (pageSize?: number) => {
  const { data, isLoading, isRefetching, refetch, fetchNextPage, isFetchingNextPage } =
    useInfiniteQuery({
      queryKey: [...queryKeys.betLoopAccountExploreProfiles, { pageSize }],
      queryFn: async ({ pageParam }: { pageParam: string | undefined }) => {
        return getBetLoopSuggestedProfiles({
          pageSize: pageSize ?? BetLoopFeedPageSize,
          pageParam,
        })
      },

      initialPageParam: undefined,

      getNextPageParam: lastPage => {
        if (!lastPage || lastPage.length < Number(pageSize ?? BetLoopFeedPageSize)) return undefined
        return lastPage[lastPage.length - 1]?.id ?? undefined
      },

      staleTime: 1_000 * 60 * 30, // 30min
      gcTime: 1_000 * 60 * 5,
      refetchOnMount: 'always',
      refetchOnWindowFocus: false,
    })

  const isEmptyState = data?.pages[0].length === 0
  const isFinalPage =
    data && data.pages[data.pages.length - 1].length < (pageSize ?? BetLoopFeedPageSize)

  return {
    data,
    isLoading,
    refetch,
    isRefetching,
    isEmptyState,
    LoadMoreButton: () =>
      isFinalPage || isEmptyState || isLoading ? null : (
        <AutoFetchButton onClick={fetchNextPage} isFetching={isFetchingNextPage} />
      ),
  }
}
